export enum ItemPublished {
  TRUE = 1,
  NOT_SAVED_AND_PUBLISH_IN_PROGRESS = 4,
  NOT_SAVED_AND_DRAFT_IN_PROGRESS = 5,
  FALSE = 9,
}
